import { FC } from 'react';
import { Modal, Text, Button, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  title?: string;
  message?: string;
}

const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({
  opened,
  onClose,
  onConfirm,
  loading = false,
  title,
  message,
}) => {
  const { t } = useTranslation(['common', 'images-tab']);

  const modalTitle = title || t('confirmDelete', { ns: 'images-tab' });
  const modalMessage =
    message || t('confirmDeleteMessage', { ns: 'images-tab' });

  return (
    <Modal opened={opened} onClose={onClose} centered title={modalTitle}>
      <Text mb="md">{modalMessage}</Text>
      <Group align="flex-end" gap="sm">
        <Button variant="default" onClick={onClose} disabled={loading}>
          {t('cancel', { ns: 'common' })}
        </Button>
        <Button color="red" onClick={onConfirm} loading={loading}>
          {t('delete', { ns: 'common' })}
        </Button>
      </Group>
    </Modal>
  );
};

export default DeleteConfirmModal;
